import React from 'react';
import { Layout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { DashboardOutlined, ClockCircleOutlined, HistoryOutlined, CheckSquareOutlined } from '@ant-design/icons';
import Header from './Header';

const { Sider, Content } = Layout;

const EmployeeLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/dashboard')
    },
    {
      key: '/timesheet',
      icon: <ClockCircleOutlined />,
      label: 'Submit Timesheet',
      onClick: () => navigate('/timesheet')
    },
    {
      key: '/tasks',
      icon: <CheckSquareOutlined />,
      label: 'My Tasks',
      onClick: () => navigate('/tasks')
    },
    {
      key: '/history',
      icon: <HistoryOutlined />,
      label: 'View History',
      onClick: () => navigate('/history')
    }
  ];

  const selectedKey = location.pathname;

  return (
    <Layout className="min-h-screen">
      <Header />
      <Layout>
        <Sider 
          width={250} 
          className="bg-white border-r border-gray-200"
          theme="light"
        >
          <div className="p-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">One Qodequay</h3>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            className="border-r-0"
            style={{
              height: 'calc(100vh - 120px)',
              borderRight: 0,
            }}
          />
        </Sider>
        <Content className="flex-1 bg-gray-50">
          <div className="p-6">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EmployeeLayout;
